import React from 'react';
import { useParams } from 'react-router-dom';
import EntityUserRoleAssignmentsPage from '@features/user/pages/EntityUserRoleAssignmentsPage';

const NationUserRoleAssignmentsPage: React.FC = () => {
  const { nationId } = useParams<{ nationId: string }>();
  return (
    <EntityUserRoleAssignmentsPage
      scope="NATION"
      scopeRefId={Number(nationId)}
      title="Nation - User role assignments"
      subtitle="Role assignments at this nation"
      workplaceNoun="nation"
      testId="nation-user-role-assignments-search"
    />
  );
};

export default NationUserRoleAssignmentsPage;
